<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll'
            )
            .line.line_horizontal(v-for='item in 7')
            .line.line_vertical(v-for='item in 7')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

//import * as basicScroll from 'basicscroll';

export default {
    props: {
        rows: {
            type: String
        },
        modifierClass: String,
        settings: Object,
        isActive: Boolean
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll();
        },
        createTimeline() {
            let horizontal = this.$refs.container.querySelectorAll('.line_horizontal'),
                vertical = this.$refs.container.querySelectorAll('.line_vertical');
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .set(horizontal, {x: '100%'})
                .set(vertical, {y: '100%'})
                .fromTo(horizontal, {x: '100%'}, {duration: 4, x: '0%'}, 0)
                .fromTo(vertical, {y: '100%'}, {duration: 4, y: '0%'}, 0);
            this.timeline.progress(0.0001);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 190vh;
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    width: 100%;
    height: 100vh;
    background-color: var(--theme);
    position: relative;
}
.line {
    --gap: calc(10vh + 10vw);
    position: absolute;
    background-color: var(--color-black);
    &_horizontal {
        height: calc(1vw + 1vh);
        width: 100vw;
        left: 0;
        &:nth-child(1) {
            top: calc(-0.5 * var(--gap));
        }
        &:nth-child(2) {
            top: calc(0.5 * var(--gap));
        }
        &:nth-child(3) {
            top: calc(1.5 * var(--gap));
        }
        &:nth-child(4) {
            top: calc(2.5 * var(--gap));
        }
        &:nth-child(5) {
            top: calc(3.5 * var(--gap));
        }
        &:nth-child(6) {
            top: calc(4.5 * var(--gap));
        }
        &:nth-child(7) {
            top: calc(5.5 * var(--gap));
        }
        &:nth-child(8) {
            top: calc(6.5 * var(--gap));
        }
    }
    &_vertical {
        width: calc(1vw + 1vh);
        height: 100vh;
        top: 0;
        &:nth-last-child(1) {
            left: calc(-0.5 * var(--gap));
        }
        &:nth-last-child(2) {
            left: calc(0.5 * var(--gap));
        }
        &:nth-last-child(3) {
            left: calc(1.5 * var(--gap));
        }
        &:nth-last-child(4) {
            left: calc(2.5 * var(--gap));
        }
        &:nth-last-child(5) {
            left: calc(3.5 * var(--gap));
        }
        &:nth-last-child(6) {
            left: calc(4.5 * var(--gap));
        }
        &:nth-last-child(7) {
            left: calc(5.5 * var(--gap));
        }
        &:nth-last-child(8) {
            left: calc(6.5 * var(--gap));
        }
    }
}
</style>
